export const translation = {
    dialog: {
        title: 'Execution History',
        loading: 'Retrieving execution history…',
        columns: {
            start: 'Start Time ({{tz}})',
            end: 'End Time ({{tz}})',
            duration: 'Duration',
            records: 'Records',
            sfDetails: 'Snowflake Details',
            sfDetailsCell: 'Warehouse: {{warehouse}}, Role: {{- role}}, User: {{- snowflakeUser}}',
            trigger: 'Trigger',
            deploymentVersion: 'Deployment Version'
        },
        filter: {
            manualTrigger: 'Manual',
            scheduledTrigger: 'Scheduled',
            dataDrivenTrigger: 'Data-Driven',
            eventDrivenTrigger: 'Event-Driven',
            apiTrigger: 'Triggered by API',
            error: 'Error'
        },
        error: {
            header: 'Error Message',
            canNotLoad: 'Failed to load execution history'
        },
        details: 'Details'
    }
};
